/*@ngInject*/
const changePasswordRepository = function (baseRepository, cryptoUtil) {

    angular.extend(this, baseRepository);

    this.changePassword = (username, oldPassword, newPassword) => {
        const url = '/rest/User/changePassword',
            data = {
                username: username,
                oldPassword: cryptoUtil.encryptWithServerPublicKey(oldPassword),
                newPassword: cryptoUtil.encryptWithServerPublicKey(newPassword)
            };

        return this.post(url, data);
    };
};

angular.module('gw-um-auth')
    .service('changePasswordRepository', changePasswordRepository);
